import { useCallback, useMemo } from "react";
import { getTranslatedPrayerNames, getSubHeaders } from "../utils/prayerCalendarUtils";
import { useHijra } from "../../../hooks/useHijra";
import { useMonthCalendar } from "../../../hooks/useMonthCalendar";
import { useLocationStore } from "../../../state/storeLocation";
import { useTimeTableMonth } from "../../../state/storeTimeTable";
import { useTimeTableColor } from "../../../state/storeTimeTableColor";
import { useTranslationStore } from "../../../state/useTranslationStore";

export const usePrayerCalendarData = (show: boolean) => {
  // State hooks
  const { HijraLocale, TimeTableMonthFullYear } = useTimeTableMonth();
  const Month = useMonthCalendar() ?? [];
  const { month } = useLocationStore();
  const { hijraLocale } = useHijra();

  // Color and style hooks
  const colorData = useTimeTableColor();

  // Translation hooks
  const translationData = useTranslationStore();

  // Today's date checker
  const isToday = useCallback((date: string) => 
    date === new Date().toISOString().split("T")[0], 
    []
  );

  // Translated prayer names
  const translatedPrayerNames = useMemo(
    () => getTranslatedPrayerNames(
      translationData.prayer_names,
      translationData.activeLanguage,
      translationData.hijralocales
    ),
    [translationData]
  );

  // Headers configuration
  const { mainHeaders, subHeaders } = useMemo(() => ({
    mainHeaders: [
      "Date",
      month.method == '13' ? 'Suhoor End' : translatedPrayerNames[0],
      "Fajr Iqamah",
      "Sunrise",
      translatedPrayerNames[1],
      "Dhuhr Iqamah",
      translatedPrayerNames[2],
      "Asr Iqamah",
      month.method == '13' ? 'Iftar Start' : translatedPrayerNames[3],
      "Maghrib Iqamah",
      translatedPrayerNames[4],
      "Isha Iqamah",
      "Midnight",
    ],
    subHeaders: getSubHeaders(
      translationData.timetable_prayer,
      translationData.activeLanguage,
      translationData.hijralocales,
      month.method ?? ''
    )
  }), [month.method, translatedPrayerNames, translationData]);

  return {
    Month,
    TimeTableMonthFullYear,
    isToday,
    translatedPrayerNames,
    mainHeaders,
    subHeaders,
    monthMethod: month.method,
    ...colorData,
    ...translationData,
    HijraLocale,
    hijraLocale
  };
};